/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import infoButton from '../../assets/assets/info_button.svg';
import arrowGray from '../../assets/assets/arrow_gray.svg';
import acessosIcon from '../../assets/assets/acesso_icon.svg';
import onlineIcon from '../../assets/assets/online_icon.svg';

import { PainelProducao } from '../../components/components/PainelProducao';
import { TipoRelatorio } from '../../components/components/TipoRelatorio';
import { Trilhas } from '../../components/components/Trilhas';
import { MonitoramentoMapa } from '../../components/components/Mapa';
import { SubMenu } from '../../components/components/Sub-Menu';
import {
  Button,
  ClassificacaoRanking,
  Container,
  ContainerBody,
  Content,
  ContentInfo,
  FiltroTotalNegociado,
  InputFiltro,
  MonitoramentoContainer,
  OpcaoFiltro,
  PainelDiv,
  Ranking,
  SubTitleDiv,
  Timer,
  TimerDiv,
  TotalNegociadoContainer,
  TotalNegociadoInfo,
} from './styles';
import { useDashboard } from '../../context/context/DashboardContext';
import { useLoading } from '../../hooks/useLoading';
import { useSelectComponent } from '../../hooks/hooks/useSelectComponent';
import { useHeaderFilter } from '../../hooks/hooks/useHeaderFilter';
import { Select } from '../../components/components/Select';
import { useUser } from '../../hooks/useUser';
import { Loader } from '../Loader/Loader';

interface Regiao {
  regiao: string;
  valor: number;
  quantidade: number;
}

interface MonitoramentoProps {
  account: string;
  appAcesso: string;
}

export function MonitoramentoOnline({
  account,
  appAcesso,
}: MonitoramentoProps) {
  let id_app_acesso: number | undefined = undefined;
  if (appAcesso === 'Whatsapp') {
    id_app_acesso = 2;
  } else if (appAcesso === 'Portal') {
    id_app_acesso = 1;
  }
  const itensRefresh = [
    '00:10:00',
    '00:20:00',
    '00:30:00',
    '00:40:00',
    '00:50:00',
    '01:00:00',
  ];
  const {
    dashboard,
    getDashboardData,
    text,
    setHistorico,
    color,
    sessao,
    getSessao,
  } = useDashboard();
  const { onOptionSelected, selectedOptions, selectedCredorOption } =
    useSelectComponent();
  const {
    dataFim,
    dataInicio,
    filtrado,
    chamado,
    setFiltro,
    filtroDataCredorDashboard,
    valorFiltros,
    online,
  } = useHeaderFilter();

  const { currentCompany } = useUser();
  const [valorRanking, setValorRanking] = useState('VALOR');
  const [ranking, setRanking] = useState<Regiao[] | undefined>([]);

  const [valor, setValor] = useState<Regiao[] | undefined>([]);
  const [quantidade, setQuantidade] = useState<Regiao[] | undefined>([]);

  const { hideLoader, showLoader, loader } = useLoading();

  const [time, setTime] = useState(0);
  const [contagemRegressiva, setContagemRegressiva] =
    useState<string>('00:10:00');
  const [hours, setHours] = useState(~~(time / 3600));
  const [minutes, setMinutes] = useState(~~((time % 3600) / 60));
  const [seconds, setSeconds] = useState(~~time % 60);

  const [timeOnline, setTimeOnline] = useState(5000);

  // selectOptions -> 00:10:00 sempre que a pagina for carregada
  useEffect(() => {
    onOptionSelected('00:10:00');
  }, []);

  // Refresh dos usuários online
  useEffect(() => {
    const timeoutOnline = setTimeout(() => {
      if (text !== 'Histórico' || online === true) {
        if (timeOnline > 0) {
          setTimeOnline(timeOnline - 1000);
        } else {
          getSessao(id_app_acesso);
          setTimeOnline(5000);
        }
      }
    }, 1000);
    return () => clearTimeout(timeoutOnline);
  }, [timeOnline, getSessao]);

  // Seta o tempo de atualização do dashboard
  useEffect(() => {
    showLoader();
    const [hr, min, seg] = selectedOptions.split(':').map(Number);
    setTime(hr * 3600 + min * 60 + seg);
    getDashboardData(
      valorFiltros.dataInicio,
      valorFiltros.dataFim,
      account === 'Principal'
        ? String(currentCompany.credor_infos.credor_crm)
        : String(currentCompany.credor_infos.conta_parcelamento),
      id_app_acesso,
    );
    hideLoader();
  }, [selectedOptions, valorFiltros, currentCompany, account, id_app_acesso]);

  // Refresh dos dados do dashboard
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (time > 0) {
        setTime(time - 1);
      } else {
        showLoader();
        const [hr, min, seg] = selectedOptions.split(':').map(Number);
        setTime(hr * 3600 + min * 60 + seg);
        getDashboardData(
          dataInicio,
          dataFim,
          selectedCredorOption,
          id_app_acesso,
        );
      }
    }, 1000);
    return () => clearTimeout(timeout);
  }, [time, selectedOptions, valorFiltros, getDashboardData, id_app_acesso]);

  // Seta o tempo de contagem regressiva
  useEffect(() => {
    setHours(~~(time / 3600));
    setMinutes(~~((time % 3600) / 60));
    setSeconds(~~time % 60);

    let hora = `${hours < 10 ? '0' : ''}${hours}`;
    let minuto = `${minutes < 10 ? '0' : ''}${minutes}`;
    let segundo = `${seconds < 10 ? '0' : ''}${seconds}`;

    setContagemRegressiva(`${hora}:${minuto}:${segundo}`);
  }, [time, hours, minutes, seconds]);

  // Seta o tempo de contagem regressiva
  useEffect(() => {
    setContagemRegressiva(selectedOptions);
  }, [selectedOptions, setContagemRegressiva]);

  // // Mostra o loader sempre que tiver um filtro selecionado
  useEffect(() => {
    showLoader();
  }, [filtrado, chamado]);

  useEffect(() => {
    if (valorRanking === 'VALOR') {
      setRanking(dashboard?.regiao?.sort((a, b) => b.valor - a.valor));
    } else {
      setRanking(
        dashboard?.regiao?.sort((a, b) =>
          a.quantidade === b.quantidade
            ? 0
            : a.quantidade > b.quantidade
            ? -1
            : 1,
        ),
      );
    }
  }, [valorRanking]);

  // // Seta o valor do ranking
  useEffect(() => {
    setRanking(dashboard?.regiao?.sort((a, b) => b.valor - a.valor));

    setValor(dashboard?.regiao);
    setQuantidade(dashboard?.regiao);

    // setCredores(dashboard?.credores?.map(String));
  }, [dashboard]);

  useEffect(() => {
    if (valor?.length === 0 && quantidade?.length === 0) {
      const regiao: Regiao[] = [
        {
          regiao: 'Norte',
          valor: 0,
          quantidade: 0,
        },
        {
          regiao: 'Nordeste',
          valor: 0,
          quantidade: 0,
        },
        {
          regiao: 'Centro-Oeste',
          valor: 0,
          quantidade: 0,
        },
        {
          regiao: 'Sul',
          valor: 0,
          quantidade: 0,
        },
        {
          regiao: 'Sudeste',
          valor: 0,
          quantidade: 0,
        },
        {
          regiao: 'Outros',
          valor: 0,
          quantidade: 0,
        },
      ];
      setValor(regiao);
      setQuantidade(regiao);
    }

    hideLoader();
  }, [valor, quantidade]);

  async function mudarTipoRelatorio() {
    setHistorico('Real Time', 'green');
    setFiltro(false);
    let isCancelar = true;
    await filtroDataCredorDashboard(isCancelar, 'dashboard');
  }

  function totalValor() {
    if (valor) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(
        valor.reduce((acc, cur) => {
          return acc + Number(cur.valor.toFixed(2));
        }, 0),
      );
    }
  }

  function totalQuantidade() {
    if (quantidade) {
      return new Intl.NumberFormat('pt-BR').format(
        quantidade.reduce((acc, cur) => {
          return acc + cur.quantidade;
        }, 0),
      );
    }
  }
  const navigate = useNavigate();
  function handleGotoAcessos() {
    localStorage.setItem('appAcesso', String(id_app_acesso));
    localStorage.setItem('account', account);
    navigate('/monitoramento/acessos-consolidados');
  }
  return (
    <>
      {loader && <Loader />}
      <Container>
        <ContainerBody>
          <Content>
            <ContentInfo>
              <PainelDiv>
                <PainelProducao
                  color="yellow"
                  quantidade={
                    dashboard?.totalAcessos
                      ? `${new Intl.NumberFormat('pt-BR').format(
                          dashboard.totalAcessos,
                        )}`
                      : '0'
                  }
                  title="Acessos"
                  icon={acessosIcon}
                />

                {text !== 'Histórico' || online === true ? (
                  <PainelProducao
                    color="green"
                    quantidade={
                      sessao
                        ? `${new Intl.NumberFormat('pt-BR').format(sessao)}`
                        : '0'
                    }
                    title="Online"
                    icon={onlineIcon}
                  />
                ) : (
                  <></>
                )}
              </PainelDiv>

              <Button
                type="button"
                onClick={text === 'Histórico' ? mudarTipoRelatorio : () => {}}
              >
                <TipoRelatorio text={text} circleColor={color} />
              </Button>
            </ContentInfo>

            <SubTitleDiv>
              <SubMenu text={appAcesso!} />
              <TimerDiv>
                <p>Tempo restante: {contagemRegressiva}</p>

                <Timer>
                  <Select
                    options={itensRefresh}
                    nameSelect="Selecione"
                    icon={arrowGray}
                    isTimer
                  />
                </Timer>
              </TimerDiv>
            </SubTitleDiv>
            <MonitoramentoContainer>
              <div className="mapa">
                <MonitoramentoMapa />
              </div>
              <TotalNegociadoContainer>
                <TotalNegociadoInfo>
                  <h2>Total Negociado</h2>
                  <div className="total">
                    <p>
                      Total:{' '}
                      {valorRanking === 'VALOR'
                        ? totalValor()
                        : totalQuantidade()}
                    </p>
                  </div>
                </TotalNegociadoInfo>

                <FiltroTotalNegociado>
                  <OpcaoFiltro>
                    <InputFiltro>
                      <input
                        type="radio"
                        value="VALOR"
                        name="filtro"
                        id="Valor"
                        checked={valorRanking === 'VALOR'}
                        onChange={(e) => setValorRanking(e.target.value)}
                      />
                      <label htmlFor="Valor">VALOR</label>
                    </InputFiltro>
                    <InputFiltro>
                      <input
                        type="radio"
                        value="QUANTIDADE"
                        name="filtro"
                        id="Quantidade"
                        onChange={(e) => setValorRanking(e.target.value)}
                      />
                      <label htmlFor="Quantidade">QUANTIDADE</label>
                    </InputFiltro>
                  </OpcaoFiltro>

                  <a onClick={handleGotoAcessos}>
                    <img src={infoButton} alt="Mais informações" />
                  </a>
                </FiltroTotalNegociado>

                {valorRanking === 'VALOR'
                  ? ranking?.map((valor, index) => {
                      return (
                        <div key={valor?.regiao}>
                          <Ranking>
                            <ClassificacaoRanking>
                              <p>{index + 1}º</p>
                            </ClassificacaoRanking>

                            <p>
                              <strong>{valor?.regiao}</strong>:{' '}
                              {new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              }).format(valor?.valor)}
                            </p>
                          </Ranking>
                        </div>
                      );
                    })
                  : ranking?.map((quantidade, index) => {
                      return (
                        <div key={quantidade?.regiao}>
                          <Ranking>
                            <ClassificacaoRanking>
                              <p>{index + 1}º</p>
                            </ClassificacaoRanking>

                            <p>
                              <strong>{quantidade?.regiao}</strong>:{' '}
                              {new Intl.NumberFormat('pt-BR').format(
                                quantidade?.quantidade,
                              )}
                            </p>
                          </Ranking>
                        </div>
                      );
                    })}
              </TotalNegociadoContainer>
            </MonitoramentoContainer>
            <Trilhas />
          </Content>
        </ContainerBody>
      </Container>
    </>
  );
}
